import testService from 'ApiService/Teacher/TestService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import AttendancesReportClass from './ReportAttendance/AttendancesReportClass';
import AttendancesReportData from './ReportAttendance/AttendancesReportData';

const AttendanceReport = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [courses, setCourses] = useState([]);
  const [classData, setClassData] = useState({
    courseId: '',
    structureId: '',
    batchId: '',
  });
  const [loadingCourses, setLoadingCourses] = useState(true);

  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Add Subject' },
  ];

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <AttendancesReportClass
            setLoading={setLoading}
            setDisable={setDisable}
            setClassData={setClassData}
            classData={classData}
            courses={courses}
            loadingCourses={loadingCourses}
          />
        );
      case 2:
        return <AttendancesReportData selectedClass={classData} />;
      default:
    }
  };
  const handleNext = async () => {
    if (disable) return;
    setLoading(true);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  const handleBack = () => {
    if (disable) return;
    setCurrentStep((cs) => cs - 1);
  };

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await testService.getAllCourses();
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };
  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px] " />
      <div
        // className={`w-md:2/3 mx-auto h-full ${
        //   currentStep === 1 ? 'w-5/6' : 'w-6/6'
        // } md:px-3  3xl:w-7/12`}
        className="mx-auto h-full w-[95%] md:w-[90%] md:px-3"
      >
        <Card
          extra={
            '-mt-[280px] w-full md:-mt-[340px] md:px-[50px] h-full mx-auto pb-3'
          }
        >
          <div className="w-full rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {currentStep === 1 ? (
            <div className="flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
              <button
                disabled={disable}
                onClick={handleNext}
                className=" linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                {loading ? 'Loading..' : 'Next'}
              </button>
            </div>
          ) : (
            <div className="flex w-full flex-col justify-center px-3 pt-2 md:flex-row  md:justify-end md:px-8">
              <button
                disabled={disable}
                onClick={handleBack}
                className="linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                Back
              </button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default AttendanceReport;
